import React from "react";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { Alert, CircularProgress, Typography } from "@mui/material";
import CreateUserForm from "../CreateUser/CreateUserForm";
import EditUserForm from "./EditUserForm";
import { usePermissions } from "../../../../context/PermissionsAndFeatures/UserPermissionsContext";
 
 
 const UsersDialogs = ({
   openAddDialog,
   onCloseAdd,
   selectedUser,
   onCloseEdit,
   selectedUserForRoots,
   onCloseRoots,
   selectedUserForBankPermissions,
   onCloseBankPermissions,
   refresh,
   maxDialogHeight = "90vh", // ✅ إضافة prop
 }) => {
   const { hasPermission, loading: permissionsLoading } = usePermissions();
   return (
     <>
       {/* Dialog لإضافة مستخدم جديد */}
       <Dialog
         open={openAddDialog}
         onClose={onCloseAdd}
         fullWidth
         maxWidth="sm"
         PaperProps={{
           sx: {
             maxHeight: maxDialogHeight, // ✅ تطبيق الارتفاع
             height: "auto",
           },
         }}
       >
         <DialogTitle>➕ إنشاء مستخدم جديد</DialogTitle>
         <DialogContent>
   <CreateUserForm
     onSuccess={() => {
       onCloseAdd();   // ✅ يقفل الديالوج
       refresh();      // ✅ يحدث جدول المستخدمين
     }}
   />
         </DialogContent>
       </Dialog>
 
       {/* Dialog لتعديل بيانات المستخدم */}
       <Dialog
         open={!!selectedUser}
         onClose={onCloseEdit}
         fullWidth
         maxWidth="sm"
         PaperProps={{
           sx: {
             maxHeight: maxDialogHeight, // ✅ تطبيق الارتفاع
             height: "auto",
           },
         }}
       >
         <DialogTitle>✏️ تعديل المستخدم</DialogTitle>
         <DialogContent>
           {permissionsLoading ? (
             <CircularProgress />
           ) : !hasPermission?.("users_edite") ? (
             <Alert severity="warning">
               عذراً، ليس لديك صلاحية تعديل المستخدمين (users_edite).
             </Alert>
           ) : (
             selectedUser ? <EditUserForm user={selectedUser} onSuccess={onCloseEdit} /> : <Typography>لا توجد بيانات للتعديل.</Typography>
           )}
         </DialogContent>
       </Dialog>
 
       {/* Dialog لربط الفروع */}
       <Dialog
         open={!!selectedUserForRoots}
         onClose={onCloseRoots}
         fullWidth
         maxWidth="sm"
         PaperProps={{
           sx: {
             maxHeight: maxDialogHeight, // ✅ تطبيق الارتفاع
             height: "auto",
           },
         }}
       >
         {/* محتوى الديالوج لربط الفروع */}
       </Dialog>
 
       {/* Dialog لصلاحيات البنوك */}
       <Dialog
         open={!!selectedUserForBankPermissions}
         onClose={onCloseBankPermissions}
         fullWidth
         maxWidth="md"
         PaperProps={{
           sx: {
             maxHeight: maxDialogHeight, // ✅ تطبيق الارتفاع
             height: "auto",
           },
         }}
       >
         {/* محتوى الديالوج لصلاحيات البنوك */}
       </Dialog>
     </>
   );
 };
 
 export default UsersDialogs;
